module.exports = __webpack_public_path__ + "static/media/java.724f6cd1.webp";